import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { store } from "@/store.ts";
import { mfeRoutePatterns } from "@webcore/services/mfe/mfePaths.ts";
import MfeBootstrap from "@/components/MfeBootstrap.tsx";
import MfeNavigationListener from "@/components/MfeNavigationListener.tsx";
import MfeRealtimeSync from "@/components/MfeRealtimeSync.tsx";
import OpsCustomViewRoute from "@/components/OpsCustomViewRoute.tsx";

/**
 * The ops container app. MfeBootstrap establishes the read-only session once, then the app's own
 * router resolves the iframe's path to what should render. The parent app embeds this at a path
 * (e.g. /dashboard/<id>/view/<viewId>/<configId>) via the shared MfeFrame component.
 */
function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <MfeNavigationListener />
        <MfeBootstrap>
          <MfeRealtimeSync />
          <Routes>
            <Route path={mfeRoutePatterns.view} element={<OpsCustomViewRoute />} />
            <Route path="*" element={<div className="p-4">Not found.</div>} />
          </Routes>
        </MfeBootstrap>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
